<p-toast
  #toast
  position="bottom-right"
  [baseZIndex]="5000"
  [showTransitionOptions]="'66ms ease-out'"
  [hideTransitionOptions]="'53ms ease-in'"
  [showTransformOptions]="'translateX(100%)'"
  [hideTransformOptions]="'translateX(100%)'"
  styleClass="sick-toast"
>
  <ng-template let-message pTemplate="message">
    <app-callout [severity]="message.severity" [closable]="true" (calloutClosed)="onClose(message)">
      <div class="toast-content">
        <h1>{{ message.summary + '.summary' | translate }}</h1>
        <div innerHtml="{{ message.summary + '.message' | translate: message.data }}"></div>
      </div>
    </app-callout>
  </ng-template>
</p-toast>
